import React from 'react';
import Icon from '../../../components/AppIcon';

const EmergencyContact = () => {
  const emergencyContacts = [
    {
      id: 1,
      title: 'Customer Service',
      description: 'For general inquiries and support',
      phone: '+211 915 497 014',
      email: 'hello@chapatiplus.com',
      icon: 'Headphones',
      available: '8:00 AM - 10:00 PM Daily'
    },
    {
      id: 2,
      title: 'Order Issues',
      description: 'Problems with your current order',
      phone: '+211 915 497 014',
      email: 'orders@chapatiplus.com',
      icon: 'AlertCircle',
      available: '8:00 AM - 10:00 PM Daily'
    },
    {
      id: 3,
      title: 'Catering & Events',
      description: 'Large orders and special events',
      phone: '+211 915 497 014',
      email: 'catering@chapatiplus.com',
      icon: 'Users',
      available: '9:00 AM - 6:00 PM Mon-Sat'
    }
  ];

  return (
    <section className="py-8 md:py-12 lg:py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Direct Contact Lines
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground">
            Reach the right department for faster assistance
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
          {emergencyContacts?.map((contact) => (
            <div
              key={contact?.id}
              className="bg-card border border-border rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-start gap-4 mb-4 md:mb-6">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Icon name={contact?.icon} size={24} color="var(--color-primary)" className="md:w-7 md:h-7" />
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-bold text-foreground mb-1">
                    {contact?.title}
                  </h3>
                  <p className="text-xs md:text-sm text-muted-foreground">
                    {contact?.description}
                  </p>
                </div>
              </div>

              <div className="space-y-3 mb-4 md:mb-6">
                <a
                  href={`tel:${contact?.phone}`}
                  className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg hover:bg-muted transition-colors duration-200 group"
                >
                  <Icon name="Phone" size={18} color="var(--color-primary)" />
                  <span className="text-sm md:text-base text-foreground font-medium group-hover:text-primary transition-colors">
                    {contact?.phone}
                  </span>
                </a>

                <a
                  href={`mailto:${contact?.email}`}
                  className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg hover:bg-muted transition-colors duration-200 group"
                >
                  <Icon name="Mail" size={18} color="var(--color-primary)" />
                  <span className="text-sm md:text-base text-foreground font-medium group-hover:text-primary transition-colors break-all">
                    {contact?.email}
                  </span>
                </a>
              </div>

              <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
                <Icon name="Clock" size={16} />
                <span>{contact?.available}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-12 bg-gradient-to-br from-primary/10 via-secondary/5 to-background border border-border rounded-2xl p-6 md:p-8 lg:p-10">
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-primary/10 rounded-2xl flex items-center justify-center flex-shrink-0">
              <Icon name="Shield" size={32} color="var(--color-primary)" className="md:w-10 md:h-10" />
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-bold text-foreground mb-2">
                Your Privacy & Security Matter
              </h3>
              <p className="text-sm md:text-base text-muted-foreground">
                All communications are secure and confidential. We never share your personal information with third parties. Your trust is our priority.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmergencyContact;